const NUMBER_RE = /\d+/g;

function stemFrenchPlurals(text) {
  return String(text)
    .replace(/\bmots\b/gi, "mot")
    .replace(/\bsessions\b/gi, "session")
    .replace(/\bparties\b/gi, "partie");
}

function compactQuestVariantLabels(labels = []) {
  const cleaned = (Array.isArray(labels) ? labels : []).filter(Boolean);
  if (!cleaned.length) return "";
  if (cleaned.length === 1) return cleaned[0];

  const sequences = cleaned.map((label) => [...label.matchAll(NUMBER_RE)].map((match) => match[0]));
  const slotCount = sequences[0]?.length || 0;
  if (!slotCount || sequences.some((sequence) => sequence.length !== slotCount)) {
    return cleaned.join(" · ");
  }

  const templates = cleaned.map((label) => stemFrenchPlurals(label.replace(NUMBER_RE, "\0")));
  if (new Set(templates).size !== 1) {
    return cleaned.join(" · ");
  }

  const skeleton = cleaned[cleaned.length - 1];
  let slot = 0;
  return skeleton.replace(NUMBER_RE, () => {
    const values = [];
    const seen = new Set();
    for (const sequence of sequences) {
      const value = sequence[slot];
      if (!seen.has(value)) {
        seen.add(value);
        values.push(value);
      }
    }
    slot += 1;
    return values.length === 1 ? values[0] : `{${values.join(", ")}}`;
  });
}

function stripTrainingSessionDuration(label) {
  return String(label || "").replace(/\s*\(\s*\d+\s+minutes?\s*\)/gi, "");
}

function formatMetamorphCandidateHint(labels) {
  const cleaned = (Array.isArray(labels) ? labels : []).map(stripTrainingSessionDuration);
  return compactQuestVariantLabels(cleaned).replace(/\/15\b/g, " sur 15");
}

module.exports = {
  compactQuestVariantLabels,
  formatMetamorphCandidateHint,
  stripTrainingSessionDuration,
};
